// 選択中ファイルへの一括タグ付け
import { ref, computed, onMounted } from 'vue';

export const useBulkTags = (basketCount, clearBasket, basketItemsList, maxInputVars, bulkMaxItems) => {
  const bulkTagsError = ref(false);
  const bulkTagsLimitExceeded = ref(false);
  const bulkTagsLimitMaxFiles = ref(0);

  const bulkTagEligibleItems = computed(() =>
    (basketItemsList.value || []).filter((item) => item.canEditTags)
  );

  const bulkTagIneligibleItems = computed(() =>
    (basketItemsList.value || []).filter((item) => !item.canEditTags)
  );

  // サーバー側検証失敗時は棚を空にしてはいけないため、成功時のみ
  // data-bulk-tags-succeeded を見て棚をクリアする
  onMounted(() => {
    const dataSource = document.getElementById('dashboard-data-source');
    if (dataSource?.getAttribute('data-bulk-tags-succeeded') === '1') {
      clearBasket();
    }
  });

  const showBulkTagModal = () => {
    if (basketCount.value < 1) return;
    bulkTagsError.value = false;
    bulkTagsLimitExceeded.value = false;
    document.dispatchEvent(new Event('clear-bulk-tags'));
    if (window.jQuery) {
      window.jQuery('#bulkTagModal').modal('show');
    }
  };

  const submitBulkTags = () => {
    const form = document.getElementById('bulkTagForm');
    if (!form || !form.querySelector('input[name="tags[]"]')) {
      bulkTagsError.value = true;
      return;
    }
    // _token を足した合計がサーバー側ガードの境界に達するなら、送っても 1 件も処理されないため送信しない。
    // サーバー側の件数上限 (config exa.bulk_max_items) とのうち小さい方を使う
    const limit = Number(maxInputVars?.value || 0);
    const videoIdCount = form.querySelectorAll('input[name="videoids[]"]').length;
    const tagIdCount = form.querySelectorAll('input[name="tags[]"]').length;
    const fromInputVars = limit > 0 ? limit - tagIdCount - 2 : 0;
    const cap = Number(bulkMaxItems?.value || 0);
    const candidates = [fromInputVars, cap].filter((n) => n > 0);
    const maxFiles = candidates.length ? Math.min(...candidates) : 0;

    if (maxFiles > 0 && videoIdCount > maxFiles) {
      bulkTagsLimitMaxFiles.value = maxFiles;
      bulkTagsLimitExceeded.value = true;
      return;
    }
    if (window.jQuery) {
      window.jQuery('#bulkTagModal').modal('hide');
    }
    form.submit();
  };

  return {
    bulkTagsError,
    bulkTagsLimitExceeded,
    bulkTagsLimitMaxFiles,
    bulkTagEligibleItems,
    bulkTagIneligibleItems,
    showBulkTagModal,
    submitBulkTags,
  };
};
